<div
  class="hx-video-tile__inner"
  [style.aspect-ratio]="aspectRatio()"
  [style.min-height.px]="1"
  (click)="tileClick.emit()">
  <!-- Video content area (always present, but styled conditionally to preserve dimensions for ACS) -->
  <div
    #videoArea
    class="hx-video-tile__video-area"
    aria-hidden="true"
    [style.opacity]="isVideoOff() ? '0' : '1'"
    [style.pointer-events]="isVideoOff() ? 'none' : 'auto'"></div>

  @if (isVideoOff()) {
    <!-- Avatar fallback -->
    <div class="hx-video-tile__avatar-area" aria-hidden="true">
      <div class="video-avatar">{{ displayInitials() }}</div>
    </div>
  }

  <!-- Speaking ring (rendered via CSS border animation) -->
  @if (isSpeaking()) {
    <div class="hx-video-tile__speaking-ring" aria-hidden="true"></div>
  }

  <!-- Top-right badges -->
  <div class="hx-video-tile__badges">
    @if (isPinned()) {
      <span class="hx-video-tile__badge hx-video-tile__badge--pin" aria-label="Pinned">
        <hx-icon svgIcon="cc-pin" aria-hidden="true" />
      </span>
    }
    @if (isConnectionPoor()) {
      <span class="hx-video-tile__badge hx-video-tile__badge--signal" aria-label="Poor connection">
        <hx-icon svgIcon="cc-wifi-slash" aria-hidden="true" />
      </span>
    }
  </div>

  <!-- Bottom overlay: name + mute indicator -->
  <div class="hx-video-tile__label">
    @if (isMuted()) {
      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z" />
      </svg>
    }
    {{ participantName() }}{{ isLocal() ? ' (You)' : '' }}
  </div>
</div>
